import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'credentials'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/credentials`

class CredentialsService {
  about () {
    return Api().get(`${root}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(`${clientRoot()}`)
  }

  findByType (type) {
    return Api().get(`${clientRoot()}/findByType/${type}`)
  }

  delete ({ credentialName }) {
    return Api().delete(`${clientRoot()}/${credentialName}`)
  }

  findById (id) {
    return Api().get(`${clientRoot()}/${id}`)
  }
}

export default new CredentialsService()
